import React from "react";
import { MainWrapper, IconWrapper, InfoWrapper, TextWrapper, DescriptionWrapper, RemoteIcon } from "./styles/Styled";
import EpgTooltipIcon from "./EpgTooltipIcon";
import { i18n } from "../../../services/i18nService";

class EpgTooltip extends React.Component {
  render() {
    return (
      <MainWrapper lang={i18n.getLocale()}>
        <IconWrapper>
          <RemoteIcon>
            <EpgTooltipIcon />
          </RemoteIcon>
        </IconWrapper>
        <InfoWrapper>
          <TextWrapper>{i18n.get("pages.livePage.tooltip.heading")}</TextWrapper>
          <DescriptionWrapper>{i18n.get("pages.livePage.tooltip.description")}</DescriptionWrapper>
        </InfoWrapper>
      </MainWrapper>
    );
  }
}

export default EpgTooltip;
